import {useEffect} from "react";
import {useSelector} from "react-redux";

import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {MultiLeadWrapper} from "../../../lead/components/MultiLeadWrapper";
import {getRecommendationFromProperty} from "../../../recommendations/utils/get_recommendation_from_property";
import {RecommendedOfferApplicationsType} from "../../actions/track_recommended_offers_application";
import {useMultiLeadRecommendations} from "../../hooks/use_multi_lead_recommendations";
import {useTransformApplicationToMultiLead} from "../../hooks/use_transform_application_to_multi_lead";
import {IApplication} from "../../types/IApplication";
import {IApplicationFormValues} from "../../types/IApplicationFormValues";
import {IMultiLeadData} from "../../types/IMultiLeadData";
import {IMultileadSummaryStepState} from "../../types/IMultileadSummaryStepState";
import {ISetMultiLeadSummaryStepPayload} from "../../types/ISetMultiLeadSummaryStepPayload";
import {MultiLeadRecommendationType} from "../../types/MultiLeadRecommendationType";
import {RecommendedPropertyApplicationsType} from "../../types/recommended_property_applications_type";
import {ApplicationSourceSection} from "../../utils/ApplicationSource";
import {isRecommendationRecommendedProperty} from "../../utils/recommended_application/recommendation_type_guards";
import {
    transformRecommendedOfferIntoMultiLeadData,
    transformRecommendedPropertyIntoMultiLeadData
} from "../../utils/recommended_application/transform_recommended_into_multi_lead_data";
import {shouldApplicationPriceBeenShown} from "../../utils/should_application_price_been_shown";
import {MultiLeadSimpleRecommendationsModal} from "./multi_lead_simple_recommendations/MultiLeadSimpleRecommendationsModal";

interface IProps {
    originalApplicationResponse: IApplication | null;
    sourceSection: ApplicationSourceSection;
    storeHash: string;
    recommendationType: MultiLeadRecommendationType;
    originalApplicationFormValues: IApplicationFormValues;
    recommendationsWithPriceFilter: boolean;
    offerId?: number;
    propertyId?: number;
    customSourceSection?: string;
    handleModalClose: (payload?: ISetMultiLeadSummaryStepPayload) => void;
    handleSetMultiLeadSummaryStep: (payload: IMultileadSummaryStepState) => void;
}

export const MultiLead = (props: IProps) => {
    const {
        handleModalClose,
        handleSetMultiLeadSummaryStep,
        originalApplicationFormValues,
        originalApplicationResponse,
        recommendationType,
        recommendationsWithPriceFilter,
        sourceSection,
        storeHash,
        customSourceSection,
        offerId,
        propertyId
    } = props;

    const {isMobile} = useUserDevice();
    const originalApplication = useSelector((store: IRPStore) => store.application[storeHash]);
    const multiLeadProperty = originalApplication?.property?.detail;
    const {transformedApplications} = useTransformApplicationToMultiLead({
        storeHash,
        originalApplicationResponse,
        originalApplication,
        multiLeadProperty
    });

    const {areRecommendationsEmpty} = useMultiLeadRecommendations({
        propertyId,
        offerId
    });

    useEffect(() => {
        if (areRecommendationsEmpty) {
            handleSetMultiLeadSummaryStep({
                multiLeadSummaryItems: transformedApplications,
                multiLeadProperty
            });
        }
    }, [areRecommendationsEmpty]);

    const onSimpleVariantSuccessfulSubmit = (applications: RecommendedPropertyApplicationsType[] | RecommendedOfferApplicationsType[]) => {
        handleSetMultiLeadSummaryStep({
            multiLeadSummaryItems: applications
                .map(([application, appliedRecommendation]) => {
                    if (isRecommendationRecommendedProperty(appliedRecommendation)) {
                        const recommendedProperty =
                            isRecommendationRecommendedProperty(appliedRecommendation) && "additional_files" in appliedRecommendation
                                ? getRecommendationFromProperty(appliedRecommendation)
                                : appliedRecommendation;
                        return transformRecommendedPropertyIntoMultiLeadData(recommendedProperty, {
                            isPriceRevealed: shouldApplicationPriceBeenShown(application)
                        });
                    }
                    if (!isRecommendationRecommendedProperty(appliedRecommendation)) {
                        return transformRecommendedOfferIntoMultiLeadData(appliedRecommendation);
                    }
                    return undefined;
                })
                .filter((item): item is IMultiLeadData => item !== undefined),
            multiLeadProperty
        });
    };

    const onCloseClick = () => {
        handleModalClose();
    };

    return (
        <MultiLeadWrapper isScrollable={Boolean(isMobile)}>
            <MultiLeadSimpleRecommendationsModal
                originalApplicationFormValues={originalApplicationFormValues}
                recommendationsWithPriceFilter={recommendationsWithPriceFilter}
                storeHash={storeHash}
                sourceSection={sourceSection}
                onModalClose={onCloseClick}
                onSuccessfulSubmit={onSimpleVariantSuccessfulSubmit}
                recommendationType={recommendationType}
                customSourceSection={customSourceSection}
                originalApplicationResponse={originalApplicationResponse}
            />
        </MultiLeadWrapper>
    );
};
import {useEffect} from "react";
import {useSelector} from "react-redux";

import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {MultiLeadWrapper} from "../../../lead/components/MultiLeadWrapper";
import {getRecommendationFromProperty} from "../../../recommendations/utils/get_recommendation_from_property";
import {RecommendedOfferApplicationsType} from "../../actions/track_recommended_offers_application";
import {useMultiLeadRecommendations} from "../../hooks/use_multi_lead_recommendations";
import {useTransformApplicationToMultiLead} from "../../hooks/use_transform_application_to_multi_lead";
import {IApplication} from "../../types/IApplication";
import {IApplicationFormValues} from "../../types/IApplicationFormValues";
import {IMultiLeadData} from "../../types/IMultiLeadData";
import {IMultileadSummaryStepState} from "../../types/IMultileadSummaryStepState";
import {ISetMultiLeadSummaryStepPayload} from "../../types/ISetMultiLeadSummaryStepPayload";
import {MultiLeadRecommendationType} from "../../types/MultiLeadRecommendationType";
import {RecommendedPropertyApplicationsType} from "../../types/recommended_property_applications_type";
import {ApplicationSourceSection} from "../../utils/ApplicationSource";
import {isRecommendationRecommendedProperty} from "../../utils/recommended_application/recommendation_type_guards";
import {
    transformRecommendedOfferIntoMultiLeadData,
    transformRecommendedPropertyIntoMultiLeadData
} from "../../utils/recommended_application/transform_recommended_into_multi_lead_data";
import {shouldApplicationPriceBeenShown} from "../../utils/should_application_price_been_shown";
import {MultiLeadSimpleRecommendationsModal} from "./multi_lead_simple_recommendations/MultiLeadSimpleRecommendationsModal";

interface IProps {
    originalApplicationResponse: IApplication | null;
    sourceSection: ApplicationSourceSection;
    storeHash: string;
    recommendationType: MultiLeadRecommendationType;
    originalApplicationFormValues: IApplicationFormValues;
    recommendationsWithPriceFilter: boolean;
    offerId?: number;
    propertyId?: number;
    customSourceSection?: string;
    handleModalClose: (payload?: ISetMultiLeadSummaryStepPayload) => void;
    handleSetMultiLeadSummaryStep: (payload: IMultileadSummaryStepState) => void;
}

export const MultiLead = (props: IProps) => {
    const {
        handleModalClose,
        handleSetMultiLeadSummaryStep,
        originalApplicationFormValues,
        originalApplicationResponse,
        recommendationType,
        recommendationsWithPriceFilter,
        sourceSection,
        storeHash,
        customSourceSection,
        offerId,
        propertyId
    } = props;

    const {isMobile} = useUserDevice();
    const originalApplication = useSelector((store: IRPStore) => store.application[storeHash]);
    const multiLeadProperty = originalApplication?.property?.detail;
    const {transformedApplications} = useTransformApplicationToMultiLead({
        storeHash,
        originalApplicationResponse,
        originalApplication,
        multiLeadProperty
    });

    const {areRecommendationsEmpty} = useMultiLeadRecommendations({
        propertyId,
        offerId
    });

    useEffect(() => {
        if (areRecommendationsEmpty) {
            handleSetMultiLeadSummaryStep({
                multiLeadSummaryItems: transformedApplications,
                multiLeadProperty
            });
        }
    }, [areRecommendationsEmpty]);

    const onSimpleVariantSuccessfulSubmit = (applications: RecommendedPropertyApplicationsType[] | RecommendedOfferApplicationsType[]) => {
        handleSetMultiLeadSummaryStep({
            multiLeadSummaryItems: applications
                .map(([application, appliedRecommendation]) => {
                    if (isRecommendationRecommendedProperty(appliedRecommendation)) {
                        const recommendedProperty =
                            isRecommendationRecommendedProperty(appliedRecommendation) && "additional_files" in appliedRecommendation
                                ? getRecommendationFromProperty(appliedRecommendation)
                                : appliedRecommendation;
                        return transformRecommendedPropertyIntoMultiLeadData(recommendedProperty, {
                            isPriceRevealed: shouldApplicationPriceBeenShown(application)
                        });
                    }
                    if (!isRecommendationRecommendedProperty(appliedRecommendation)) {
                        return transformRecommendedOfferIntoMultiLeadData(appliedRecommendation);
                    }
                    return undefined;
                })
                .filter((item): item is IMultiLeadData => item !== undefined),
            multiLeadProperty
        });
    };

    const onCloseClick = () => {
        handleModalClose();
    };

    return (
        <MultiLeadWrapper isScrollable={Boolean(isMobile)}>
            <MultiLeadSimpleRecommendationsModal
                originalApplicationFormValues={originalApplicationFormValues}
                recommendationsWithPriceFilter={recommendationsWithPriceFilter}
                storeHash={storeHash}
                sourceSection={sourceSection}
                onModalClose={onCloseClick}
                onSuccessfulSubmit={onSimpleVariantSuccessfulSubmit}
                recommendationType={recommendationType}
                customSourceSection={customSourceSection}
                originalApplicationResponse={originalApplicationResponse}
            />
        </MultiLeadWrapper>
    );
};
